module.exports = __webpack_public_path__ + "static/media/setup_img1.1016e702.png";